import React, { useEffect, useMemo, useState, useRef } from "react";
import { FixedSizeList as List } from "react-window";
import Select from "react-select"; // Importando React-Select
import { Link, useLocation, } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";
import "./ListagemLeads.css";


function ListagemLeads() {
  const [leads, setLeads] = useState([]);
  const [tags, setTags] = useState([]);
  const [filters, setFilters] = useState({
    nome: "",
    origem: "",
    estagio: "",
    tags: [],
    excludeTags: [], 
    tagsAnd: false,
    telefone: "",
  });
  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");
  const [tipoUsuario, setTipoUsuario] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const hoje = new Date().toISOString().split("T")[0];
  const [dataInicio, setDataInicio] = useState("2025-01-01");
  const [dataFim, setDataFim] = useState(hoje);
  const [leadsSelecionados, setLeadsSelecionados] = useState([]);
  const [mensagemFila, setMensagemFila] = useState("");
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [delaySegundos, setDelaySegundos] = useState(5);
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [mostrarEmojiPicker, setMostrarEmojiPicker] = useState(false);
  const [arquivoUrl, setArquivoUrl] = useState("");
  const [tipoMidia, setTipoMidia] = useState("");
  const [uploadEmAndamento, setUploadEmAndamento] = useState(false);
  const [bulkTags, setBulkTags] = useState([]);   
  const [addingTags, setAddingTags] = useState(false);
  const location = useLocation();
  const msgRef = useRef(null);
  const [rrVisivel, setRrVisivel] = useState(false);
  const [rrLista, setRrLista] = useState([]);
  const [rrFiltro, setRrFiltro] = useState('');
  const [rrIndex, setRrIndex] = useState(0);
  const [nomeArquivo, setNomeArquivo] = useState("");
  const rrRef = useRef(null);
  const [lastClickedId, setLastClickedId] = useState(null);
  const telTimerRef = useRef(null);
  const nomeTimerRef = useRef(null);
  const fetchAbortRef = useRef(null);
  const fileInputRef = useRef(null);
  const includeOptions = useMemo(
  () => tags.filter(opt => !filters.excludeTags.some(e => e.value === opt.value)),
  [tags, filters.excludeTags]
);

const excludeOptions = useMemo(
  () => tags.filter(opt => !filters.tags.some(t => t.value === opt.value)),
  [tags, filters.tags]
);



const onTelefoneChange = (novo) => {
  if (telTimerRef.current) clearTimeout(telTimerRef.current);
  setFilters(prev => {
    const next = { ...prev, telefone: novo };
    telTimerRef.current = setTimeout(() => fetchLeadsComValor(next), 400);
    return next;
  });
};

const onNomeChange = (novo) => {
  if (nomeTimerRef.current) clearTimeout(nomeTimerRef.current);
  setFilters(prev => {
    const next = { ...prev, nome: novo };
    nomeTimerRef.current = setTimeout(() => fetchLeadsComValor(next), 400);
    return next;
  });
};


  const insertToken = (token) => {
  setMensagemFila((prev) => {
    const el = msgRef.current;
    if (!el || typeof el.selectionStart !== "number") return prev + token;

    const start = el.selectionStart;
    const end   = el.selectionEnd;
    const next  = prev.slice(0, start) + token + prev.slice(end);

    requestAnimationFrame(() => {
      try {
        el.focus();
        const pos = start + token.length;
        el.setSelectionRange(pos, pos);
      } catch {}
    });

    return next;
  });
};

const buscarRespostasRapidas = async (q = '') => {
  try {
    const url = q
      ? `/crm-wly/api/whatsapp/respostas_rapidas.php?q=${encodeURIComponent(q)}`
      : `/crm-wly/api/whatsapp/respostas_rapidas.php`;
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();
    if (data.success && Array.isArray(data.data)) setRrLista(data.data);
    else setRrLista([]);
  } catch {
    setRrLista([]);
  }
};

async function runBatches(items, batchSize, fn) {
  let i = 0;
  while (i < items.length) {
    const slice = items.slice(i, i + batchSize);
    await Promise.all(slice.map(fn));
    i += batchSize;
  }
}


const ROW_HEIGHT = 60;

function RowDiv({ index, style, data }) {
  const { sortedLeads, leadsSelecionados, toggleLeadSelecionado } = data;
  const lead = sortedLeads[index];
  const checked = leadsSelecionados.includes(lead.id);

  return (
    <div
      className="row-virtualizada"
      style={{
        ...style,
        display: "grid",
        gridTemplateColumns: "40px 70px 1fr 170px 160px 160px 1fr 300px",
        alignItems: "center",
        boxSizing: "border-box",
        padding: "0 8px",
        minHeight: ROW_HEIGHT,
        background: index % 2 === 0 ? "#2b2b3a" : "#232332",
        color: "#fff",
        borderBottom: "1px solid #3a3a4a",
      }}
    >
      <div>
      <input
        type="checkbox"
        checked={checked}
        readOnly // evita warning do React
        onClick={(e) => {
          e.preventDefault();                 // impede o toggle automático do browser
          toggleLeadSelecionado(lead.id, e.shiftKey); // usa o Shift aqui
        }}
      />


      </div>

      <div>{lead.id}</div>

      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {lead.nome}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <Link
          to={`/wzp/painel-mensagens?telefone=${encodeURIComponent(lead.telefone)}&leadId=${lead.id}`}
          className="button-wzp"
          style={{
            display: "inline-block",
            maxWidth: 160,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {lead.telefone}
        </Link>
      </div>

      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {lead.origem_lead}
      </div>

      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {lead.estagio_funil}
      </div>

      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {lead.tags ? lead.tags.split(", ").join(" | ") : "Sem tags"}
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "nowrap",          // NÃO quebrar linha
          overflow: "hidden",          // evita estourar
        }}
      >
        <Link to={`/lead-detalhes/${lead.id}`} className="button">Detalhes</Link>
        <Link to={`/editar-lead/${lead.id}`} className="button">Editar</Link>
        <Link to={`/criar-acao/${lead.id}`} state={{ lead }} className="button">Criar Ação</Link>
      </div>
    </div>
  );
}


const handleAdicionarTagsEmMassa = async () => {
  if (leadsSelecionados.length === 0) {
    window.alert("Selecione pelo menos um lead.");
    return;
  }
  if (!bulkTags.length) {
    window.alert("Selecione pelo menos uma tag.");
    return;
  }

if (!window.confirm(`Adicionar ${bulkTags.length} tag(s) em ${leadsSelecionados.length} lead(s)?`)) {
  return;
}


  setAddingTags(true);
  try {
    // Monta pares (lead, tag)
    const pares = [];
    for (const leadId of leadsSelecionados) {
      for (const tag of bulkTags) {
        pares.push({ leadId, tagId: tag.value });
      }
    }

    // Dispara em lotes (ex: 20 por vez)
    await runBatches(pares, 20, async ({ leadId, tagId }) => {
      // ajuste o endpoint se seu arquivo estiver em outro caminho
      const res = await fetch("/crm-wly/lead_tags.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "add",      // sua API já deve aceitar add/remove
          lead_id: leadId,
          tag_id: tagId
        })
      });
      const data = await res.json().catch(() => ({}));
      if (!data.success) {
        // Falha silenciosa por par; você pode coletar erros num array se preferir
        console.warn("Falha ao adicionar tag", { leadId, tagId, data });
      }
    });

    // Atualiza listagem e limpa seleção
    await fetchLeads();
    setLeadsSelecionados([]);
    setBulkTags([]);
    window.alert("Tags adicionadas aos selecionados.");
  } catch (e) {
    console.error(e);
    window.alert("Ocorreu um erro ao adicionar tags em massa.");
  } finally {
    setAddingTags(false);
  }
};



const tokenBtnStyle = { display: "inline-flex", alignItems: "center", justifyContent: "center", height: 24, padding: "2px 8px", fontSize: 12, lineHeight: 1, borderRadius: 6, color: "white", border: "1px solid #d0d0d0", background: "#c7c7c7", cursor: "pointer", whiteSpace: "nowrap", width: "auto", minWidth: 0, maxWidth: "none", appearance: "none", paddingBottom: "3px", paddinTop: "3px" };

const hasTagParam = useMemo(() => {
  const p = new URLSearchParams(location.search);
  return !!(p.get("tag") || p.get("tags"));
}, [location.search]);
  
const normalizarDataAgendamento = (valor) => {
  if (!valor) return "";

  // já está em yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor;

  // converte dd/mm/yyyy para yyyy-mm-dd
  const m = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) {
    const [, dd, mm, yyyy] = m;
    return `${yyyy}-${mm}-${dd}`;
  }

  return "";
};

const dataAgendamentoNormalizada = normalizarDataAgendamento(dataAgendamento);

const agendado_em =
  dataAgendamentoNormalizada && horaAgendamento
    ? `${dataAgendamentoNormalizada} ${horaAgendamento}:00`
    : null;

const fecharPopup = () => {
  setMostrarPopup(false);
  setMensagemFila("");
  setArquivoUrl("");
  setTipoMidia("");
  setDataAgendamento("");
  setHoraAgendamento("");

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};


  const handleEnviarFila = async () => {
  if (!mensagemFila.trim() && !arquivoUrl) {
    alert("Digite uma mensagem ou anexe um arquivo para enviar.");
    return;
  }

  try {
    setEnviando(true);

        const dataNormalizadaAgora = normalizarDataAgendamento(dataAgendamento);
    const horaNormalizadaAgora = (horaAgendamento || "").trim();

    const agendadoEmAgora =
      dataNormalizadaAgora && horaNormalizadaAgora
        ? `${dataNormalizadaAgora} ${horaNormalizadaAgora}:00`
        : null;

    console.log("AGENDAMENTO DEBUG", {
      dataAgendamento,
      horaAgendamento,
      dataNormalizadaAgora,
      agendadoEmAgora
    });

    const fecharPopup = () => {
  setMostrarPopup(false);
  setMensagemFila("");
  setArquivoUrl("");
  setTipoMidia("");

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

    if ((dataAgendamento && !horaAgendamento) || (!dataAgendamento && horaAgendamento)) {
      alert("Preencha a data e a hora do agendamento.");
      setEnviando(false);
      return;
    }

    if ((dataAgendamento || horaAgendamento) && !agendadoEmAgora) {
      alert("Data ou hora de agendamento inválida.");
      setEnviando(false);
      return;
    }
    
const res = await fetch("/crm-wly/api/whatsapp/criar_fila_zapi.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  credentials: "include",
  body: JSON.stringify({
    lead_ids: leadsSelecionados,
    mensagem: mensagemFila,
    tipo_midia: tipoMidia || null,
    midia_url: arquivoUrl || null,
    delay_envio: delaySegundos,
    agendado_em: agendadoEmAgora
  })
});


    const data = await res.json();
    if (data.success) {
      alert("Mensagens adicionadas à fila com sucesso!");
      setMostrarPopup(false);
      setLeadsSelecionados([]);
      setMensagemFila("");
    } else {
      alert("Erro ao adicionar na fila: " + data.message);
    }
  } catch (err) {
    console.error("Erro ao enviar:", err);
    alert("Erro ao enviar mensagens.");
  } finally {
    setEnviando(false);
  }
};
  
const toggleLeadSelecionado = (leadId, shiftKey) => {
  setLeadsSelecionados((prev) => {
    // índice da linha atual na lista ordenada
    const currentIndex = sortedLeads.findIndex((l) => l.id === leadId);

    // se estiver com Shift e já tiver um clique anterior válido
    if (shiftKey && lastClickedId !== null && currentIndex !== -1) {
      const lastIndex = sortedLeads.findIndex((l) => l.id === lastClickedId);

      if (lastIndex !== -1) {
        const start = Math.min(lastIndex, currentIndex);
        const end   = Math.max(lastIndex, currentIndex);

        const idsIntervalo = sortedLeads.slice(start, end + 1).map((l) => l.id);

        const jaSelecionados = new Set(prev);
        const tudoJaMarcado = idsIntervalo.every((id) => jaSelecionados.has(id));

        // se todas já estavam marcadas, desmarca o intervalo
        if (tudoJaMarcado) {
          return prev.filter((id) => !idsIntervalo.includes(id));
        }

        // senão, marca todas do intervalo
        return Array.from(new Set([...prev, ...idsIntervalo]));
      }
    }

    // clique normal (sem Shift): toggle só do lead
    if (prev.includes(leadId)) {
      return prev.filter((id) => id !== leadId);
    } else {
      return [...prev, leadId];
    }
  });

  // guarda o último ID clicado (sempre, com ou sem Shift)
  setLastClickedId(leadId);
};


const toggleTodosLeads = () => {
  if (leadsSelecionados.length === sortedLeads.length) {
    setLeadsSelecionados([]);
  } else {
    setLeadsSelecionados(sortedLeads.map((lead) => lead.id));
  }
};

useEffect(() => {
  return () => {
    if (fetchAbortRef.current) fetchAbortRef.current.abort();
    if (telTimerRef.current) clearTimeout(telTimerRef.current);
    if (nomeTimerRef.current) clearTimeout(nomeTimerRef.current);
  };
}, []);


useEffect(() => {
  fetchTags();
}, []);

useEffect(() => {
  fetchTags(usuarioSelecionado);
}, [usuarioSelecionado]);

useEffect(() => {
  if (hasTagParam) return;       
  fetchLeads();
}, [usuarioSelecionado, hasTagParam]);



useEffect(() => {
  fetch("https://welaunchyou.com.br/crm-wly/listagem_usuarios.php", {
    credentials: "include",
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.usuarios) setUsuarios(data.usuarios);
      if (data.tipo_usuario) setTipoUsuario(data.tipo_usuario);
    });
}, []);

useEffect(() => {
  const p = new URLSearchParams(location.search);
  const di = p.get("data_inicio");
  const df = p.get("data_fim");
  if (di) setDataInicio(di);
  if (df) setDataFim(df);
}, [location.search]);


useEffect(() => {
  if (!tags || tags.length === 0) return;

  const params  = new URLSearchParams(location.search);
  const single  = params.get("tag");
  const many    = params.get("tags");
  const andFlag = params.get("tags_and") === "1";
  const di      = params.get("data_inicio");
  const df      = params.get("data_fim");

  if (!single && !many) return;

  const ids = (many || single || "")
    .split(",")
    .map((s) => parseInt(s, 10))
    .filter((n) => !Number.isNaN(n));
  if (ids.length === 0) return;

  const selecionadas = tags.filter((opt) => ids.includes(opt.value));

  // Atualiza filtros visuais
  setFilters((prev) => ({ ...prev, tags: selecionadas, tagsAnd: andFlag }));

  // Faz o fetch já respeitando datas vindas da URL (se houver)
  fetchLeadsComValor({
    ...filters,
    tags: selecionadas,
    tagsAnd: andFlag,
    data_inicio: di || undefined,
    data_fim: df || undefined,
  });
}, [tags, location.search]); 


  const fetchLeads = async () => {
    try {
      const filteredParams = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== "" && v.length > 0)
      );

      if (filteredParams.tags) {
        filteredParams.tags = filteredParams.tags.map(t => t.value).join(',');
      }
      if (filters.tagsAnd) {
        filteredParams.tags_and = "1"; // Define o filtro para buscar leads com TODAS as tags
      }

      if (tipoUsuario === "master" && usuarioSelecionado) {
        filteredParams.usuario_id = usuarioSelecionado;
      }

      if (dataInicio) filteredParams.data_inicio = dataInicio;
      if (dataFim) filteredParams.data_fim = dataFim;

      // dentro de fetchLeads()
      if (filters.excludeTags?.length) {
        filteredParams.exclude_tags = filters.excludeTags.map(t => t.value).join(',');
      }


      const queryString = new URLSearchParams(filteredParams).toString();
      const url = `https://welaunchyou.com.br/crm-wly/listagem_leads.php${
        queryString ? `?${queryString}` : ""
      }`;

      console.log("URL da requisição:", url);

      const response = await fetch(url, { credentials: "include" });

      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status}`);
      }

      const data = await response.json();
      console.log("Dados recebidos:", data);

      if (Array.isArray(data.leads)) {
        setLeads(data.leads);
      } else {
        console.error("Formato inesperado dos dados recebidos:", data);
        setLeads([]);
      }
    } catch (error) {
      console.error("Erro ao buscar os leads:", error);
      setLeads([]);
    }
  };

  const fetchLeadsComValor = async (filtrosOverride = {}) => {
  try {
    // aborta requisição anterior
    if (fetchAbortRef.current) fetchAbortRef.current.abort();
    const controller = new AbortController();
    fetchAbortRef.current = controller;

    const isEmpty = (v) =>
      v == null ||
      (typeof v === "string" && v.trim() === "") ||
      (Array.isArray(v) && v.length === 0);

    const filteredParams = {};

    // Campos básicos vindos do override
    for (const [k, v] of Object.entries(filtrosOverride)) {
      if (["tags", "excludeTags", "tagsAnd"].includes(k)) continue;
      if (!isEmpty(v)) filteredParams[k] = v;
    }

    // Tags incluídas
    if (Array.isArray(filtrosOverride.tags) && filtrosOverride.tags.length) {
      filteredParams.tags = filtrosOverride.tags.map((t) => t.value).join(",");
    }

    // Excluir tags
    const ex = filtrosOverride.excludeTags;
    if (Array.isArray(ex) && ex.length) {
      filteredParams.exclude_tags = ex.map((t) => t.value).join(",");
    }

    // AND/OR das tags
    if (filtrosOverride.tagsAnd) filteredParams.tags_and = "1";

    // Datas: override > estado
    const di = filtrosOverride.data_inicio || dataInicio;
    const df = filtrosOverride.data_fim || dataFim;
    if (!isEmpty(di)) filteredParams.data_inicio = di;
    if (!isEmpty(df)) filteredParams.data_fim = df;

    // Master
    if (tipoUsuario === "master" && usuarioSelecionado) {
      filteredParams.usuario_id = usuarioSelecionado;
    }

    const queryString = new URLSearchParams(filteredParams).toString();
    const url = `https://welaunchyou.com.br/crm-wly/listagem_leads.php${queryString ? `?${queryString}` : ""}`;

    const response = await fetch(url, {
      credentials: "include",
      signal: controller.signal,
    });
    if (!response.ok) throw new Error(`Erro: ${response.status}`);

    const data = await response.json();
    setLeads(Array.isArray(data.leads) ? data.leads : []);
  } catch (err) {
    if (err.name !== "AbortError") {
      console.error("Erro ao buscar leads:", err);
      setLeads([]);
    }
  }
};


const fetchTags = async (usuarioId = "") => {
  try {
    const base = "https://welaunchyou.com.br/crm-wly/tags.php";
    const url = usuarioId ? `${base}?usuario_id=${usuarioId}` : base;

    const response = await fetch(url, { credentials: "include" });
    const raw = await response.text(); // lê tudo como texto

    if (!response.ok) {
      console.error("tags.php retornou status", response.status, "body:", raw);
      throw new Error(`Erro ao buscar tags: ${response.status}`);
    }

    let data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      console.error("tags.php NÃO retornou JSON válido. Resposta foi:\n", raw);
      throw new Error("Resposta de tags.php não é JSON válido");
    }

    const lista = Array.isArray(data)
      ? data
      : Array.isArray(data.tags)
      ? data.tags
      : Array.isArray(data.resumo)
      ? data.resumo
      : [];

    setTags(lista.map((tag) => ({ value: Number(tag.id), label: tag.nome })));
  } catch (error) {
    console.error("Erro ao carregar tags:", error);
    setTags([]);
  }
};


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleTagFilterChange = (selected) => {
    const sel = selected || [];
    setFilters(prev => ({
      ...prev,
      tags: sel,
      excludeTags: prev.excludeTags.filter(e => !sel.some(t => t.value === e.value)),
    }));
  };

  const handleExcludeChange = (selected) => {
    const sel = selected || [];
    setFilters(prev => ({
      ...prev,
      excludeTags: sel,
      tags: prev.tags.filter(t => !sel.some(e => e.value === t.value)),
    }));
  };


  const handleTagsAndToggle = () => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      tagsAnd: !prevFilters.tagsAnd,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchLeads();
  };

  const [sortConfig, setSortConfig] = useState({ key: "nome", direction: "asc" });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedLeads = React.useMemo(() => {
  const arr = [...leads];
  const { key, direction } = sortConfig;
  arr.sort((a, b) => {
    if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
    if (a[key] > b[key]) return direction === "asc" ?  1 : -1;
    return 0;
  });
  return arr;
}, [leads, sortConfig]);


    const totalExibidos = sortedLeads.length;

  


 return (
    <div className="listagem-container">
      <h1>Listagem de Leads</h1>

      {/* Formulário de Filtros */}
      <form className="filter-form" onSubmit={handleFilterSubmit}>

      <div className="form-group">
  <label htmlFor="dataInicio">Data Início:</label>
  <input
    type="date"
    id="dataInicio"
    value={dataInicio}
    onChange={(e) => setDataInicio(e.target.value)}
  />
</div>

<div className="form-group">
  <label htmlFor="dataFim">Data Fim:</label>
  <input
    type="date"
    id="dataFim"
    value={dataFim}
    onChange={(e) => setDataFim(e.target.value)}
  />
</div>


        <div className="form-filtros">
          {tipoUsuario === "master" && (
  <div className="form-group">
    <label htmlFor="usuario_id">Usuário:</label>
    <select
      id="usuario_id"
      value={usuarioSelecionado}
      onChange={(e) => {
  setUsuarioSelecionado(e.target.value);
  setFilters((prev) => ({ ...prev, tags: [] }));
}}
    >
      <option value="">Todos</option>
      {usuarios.map((user) => (
        <option key={user.id} value={user.id}>
          {user.nome || "Sem nome"}
        </option>
      ))}
    </select>
  </div>
)}

          <div className="form-group">
            <label htmlFor="nome">Nome:</label>
            <input
              type="text"
              id="nome"
              name="nome"
              placeholder="Digite o nome..."
              value={filters.nome}
              onChange={(e)=>onNomeChange(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefone">Telefone:</label>
            <input
              type="text"
              id="telefone"
              name="telefone"
              value={filters.telefone || ""}
              onChange={(e)=>onTelefoneChange(e.target.value)}
              placeholder="Digite o telefone..."
            />
          </div>


          <div className="form-group">
            <label htmlFor="origem">Origem:</label>
            <select
              id="origem"
              name="origem"
              value={filters.origem}
              onChange={handleFilterChange}
            >
              <option value="">Todas</option>
              <option value="Facebook">Facebook</option>
              <option value="Instagram">Instagram</option>
              <option value="Google Ads">Google Ads</option>
              <option value="Indicação">Indicação</option>
              <option value="Nórea CRM">Nórea CRM</option>

            </select>
          </div>

          <div className="form-group">
            <label htmlFor="estagio">Estágio do Funil:</label>
            <select
              id="estagio"
              name="estagio"
              value={filters.estagio}
              onChange={handleFilterChange}
            >
              <option value="">Todos</option>
              <option value="Contato Inicial">Contato Inicial</option>
              <option value="Qualificação">Qualificação</option>
              <option value="Agendamento">Agendamento</option>
              <option value="Acompanhamento">Acompanhamento</option>
              <option value="Agendado">Agendado</option>
              <option value="Cliente">Cliente</option>
            </select>
          </div>

          {/* Filtro de Tags */}
          <div className="form-group2">
            <label>Tags:</label>
            <div className="tag-filter-container">
            <Select
  options={tags}
  isMulti
  closeMenuOnSelect={false}
  value={filters.tags}
  onChange={handleTagFilterChange}
  placeholder="Selecione as tags..."
  className="tag-select"
  classNamePrefix="tags"           // prefixo pro CSS do react-select
  menuPortalTarget={document.body} // dropdown acima de tudo
  styles={{
    container: (base) => ({ ...base, minWidth: 320, flexGrow: 1 }),
    control:   (base, state) => ({
      ...base,
      minHeight: 40,
      height: 40,
      backgroundColor: "#fff",
      borderColor: state.isFocused ? "#007bff" : "#444",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({ ...base, padding: "2px 8px" }),
    indicatorsContainer: (base) => ({ ...base, height: 40 }),
    dropdownIndicator: (base) => ({ ...base, padding: 6 }),
    clearIndicator: (base) => ({ ...base, padding: 6 }),
    multiValue: (base) => ({ ...base, backgroundColor: "#3a3a4d" }),
    multiValueLabel: (base) => ({ ...base, color: "#fff" }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#fff",
      ":hover": { backgroundColor: "#ff4d4d", color: "#fff" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, backgroundColor: "#2c2c3e" }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? "#2c2c3e" : isFocused ? "#3a3a4d" : "#2c2c3e",
      color: "#fff",
      cursor: "pointer",
    }),
  }}
/>


              <div className="toggle-container">
  <span className={!filters.tagsAnd ? "active" : ""}>Alguma das</span>
  <label className="switch">
    <input type="checkbox" checked={filters.tagsAnd} onChange={handleTagsAndToggle} />
    <span className="slider round"></span>
  </label>
  <span className={filters.tagsAnd ? "active" : ""}>Todas as</span>
</div>

            </div>

<div className="form-group2">
  <label style={{ display: "block" }}>
    Excluir
    <span className="comentario-excluir">(Não aparecer leads com as tags)</span>
  </label>
<Select
  options={excludeOptions}
  isMulti
  closeMenuOnSelect={false}
  value={filters.excludeTags}
  onChange={handleExcludeChange}
  placeholder="Selecione as tags a excluir…"
  menuPortalTarget={document.body}
  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
/>

</div>


          </div>

          <div>
            <button type="submit">Filtrar</button>
          </div>
        </div>
      </form>

{/* Barra acima da tabela */}
<div
  className="list-toolbar"
  style={{
    margin: '12px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }}
>
  {/* Esquerda: selecionados (mostra só se houver) */}
  {leadsSelecionados.length > 0 ? (
    <div className="selection-info" style={{ fontWeight: 600 }}>
      {leadsSelecionados.length} selecionado(s)
    </div>
  ) : <div />}

  {/* Direita: total exibido (sempre mostra) */}
  <div className="display-count" style={{ opacity: 0.9 }}>
    {totalExibidos} lead{totalExibidos === 1 ? '' : 's'} exibido{totalExibidos === 1 ? '' : 's'}
  </div>
</div>

{leadsSelecionados.length > 0 && (
  <div className="bulk-actions">
    <div className="title">
      Associar Tag(s) em massa para {leadsSelecionados.length} selecionado(s):
    </div>

    <div className="select-narrow">
      <Select
        options={tags}
        isMulti
        closeMenuOnSelect={false}
        value={bulkTags}
        onChange={(sel) => setBulkTags(sel || [])}
        placeholder="Adicionar tag(s)…"
        classNamePrefix="tags"           // mesmo prefixo do filtro
        menuPortalTarget={document.body}
      />
    </div>

    <button
      onClick={handleAdicionarTagsEmMassa}
      disabled={addingTags || bulkTags.length === 0}
      className="button-tag"
      title={
        bulkTags.length === 0
          ? "Selecione ao menos uma tag"
          : "Adicionar tags aos selecionados"
      }
    >
      {addingTags ? "Aplicando..." : "Adicionar tags aos selecionados"}
    </button>
  </div>
)}



   {/* Lista virtualizada de Leads (sem <table>) */}
<div className="leads-virtualized">

  {/* Cabeçalho fixo */}
<div
  className="leads-header-row"
  style={{
    display: "grid",
    gridTemplateColumns: "40px 70px 1fr 170px 160px 160px 1fr 300px",
    alignItems: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#3a3a4a",
    color: "white",
    padding: "10px 8px",
    borderRadius: 4
  }}
>
    <div>
      <input
        type="checkbox"
        checked={sortedLeads.length > 0 && leadsSelecionados.length === sortedLeads.length}
        onChange={toggleTodosLeads}
      />
    </div>
    <div>ID</div>
    <div style={{cursor:"pointer"}} onClick={() => handleSort("nome")}>
      Nome {sortConfig.key === "nome" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
    </div>
    <div>Telefone</div>
    <div>Origem</div>
    <div>Estágio</div>
    <div>Tags</div>
    <div>Ações</div>
  </div>

  {/* Corpo virtualizado */}
<div style={{ height: 560 }}>
  {sortedLeads.length > 0 ? (
    <List
      height={560}
      width={"100%"}
      itemCount={sortedLeads.length}
      itemSize={ROW_HEIGHT}
      overscanCount={5}
      itemData={{ sortedLeads, leadsSelecionados, toggleLeadSelecionado }}
      itemKey={(index, data) => data.sortedLeads[index].id}
    >
      {RowDiv}
    </List>
  ) : (
    <div style={{ padding: 16, color: "white" }}>Nenhum lead encontrado.</div>
  )}
</div>
</div>



{leadsSelecionados.length > 0 && (
  <button
    className="botao-flutuante-wzp"
    onClick={() => setMostrarPopup(true)}
  >
    <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" />
    Enviar Mensagem
  </button>
)}


  {mostrarPopup && (
  <div className="popup-backdrop">
    <div className="popup-content">
      <h3>Confirme a mensagem</h3>
      <p>
        <strong>{leadsSelecionados.length}</strong> contato(s) selecionado(s).
      </p>



      {/* 1) Wrapper apenas para o textarea + emoji */}
      <div style={{ position: "relative", marginBottom: 12, paddingBottom: 8 }}>
          <textarea
          ref={msgRef}
          value={mensagemFila}
          onChange={async (e) => {
            const txt = e.target.value;
            setMensagemFila(txt);

            const cursor = e.target.selectionStart || txt.length;
            const ateCursor = txt.slice(0, cursor);
            const match = ateCursor.match(/\/([\w-]*)$/); // igual ao Painel

            if (match) {
              const termo = match[1] || '';
              setRrFiltro(termo);
              setRrVisivel(true);
              setRrIndex(0);
              await buscarRespostasRapidas(termo);
            } else {
              setRrVisivel(false);
            }
          }}
          onKeyDown={(e) => {
            if (!rrVisivel) return;

            if (e.key === 'ArrowDown') { e.preventDefault(); setRrIndex(i => Math.min(i + 1, rrLista.length - 1)); }
            if (e.key === 'ArrowUp')   { e.preventDefault(); setRrIndex(i => Math.max(i - 1, 0)); }
            if (e.key === 'Escape')    { setRrVisivel(false); }
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              const item = rrLista[rrIndex];
              if (!item) return;
              setMensagemFila(prev => prev.replace(/\/[\w-]*$/, item.conteudo));
              setRrVisivel(false);
            }
          }}
          rows={6}
          placeholder='Digite a mensagem (use "/" para respostas rápidas)'
          style={{
            width: "100%",
            boxSizing: "border-box",
            borderRadius: 8,
            // espaço pro botão de emoji no canto direito
            padding: "12px 44px 12px 12px",
            fontSize: 15,
            border: "1px solid #ccc",
            backgroundColor: "#ece5dd",
          }}
        />

        {rrVisivel && rrLista.length > 0 && (
  <div ref={rrRef} className="rr-popup" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000, width: '100%' }}>
    {rrLista.map((r, i) => (
      <div
        key={r.id}
        onMouseDown={(ev) => {
          ev.preventDefault(); // não perder foco do textarea
          setMensagemFila(prev => prev.replace(/\/[\w-]*$/, r.conteudo));
          setRrVisivel(false);
        }}
        style={{
          padding: '10px 12px',
          cursor: 'pointer',
          background: i === rrIndex ? '#f3f6ff' : '#fff',
          border: '1px solid #eee',
          borderTop: 'none'
        }}
      >
        <div style={{ fontWeight: 600 }}>{r.atalho} — {r.titulo}</div>
        <div style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {r.conteudo}
        </div>
      </div>
    ))}
  </div>
)}


  <button
    type="button"
    onClick={() => setMostrarEmojiPicker((prev) => !prev)}
    style={{
      position: "absolute",
      bottom: 12,
      right: 12,
      background: "none",
      border: "none",
      fontSize: 20,
      lineHeight: 1,
      cursor: "pointer",
    }}
    aria-label="Inserir emoji"
  >
    😊
  </button>

  {mostrarEmojiPicker && (
    <div style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}>
      <EmojiPicker
        onEmojiClick={({ emoji }) => {
          setMensagemFila((prev) => prev + emoji);
          setMostrarEmojiPicker(false);
        }}
        autoFocusSearch={false}
        height={350}
        width={300}
        theme="light"
      />
    </div>
  )}
</div>

{/* 3) Barra de variáveis FORA do wrapper (não sobrepõe emoji) */}
<div className="popup-mensagem-wzp">
  <span style={{ fontSize: 12, opacity: 0.8 }}>Variáveis:</span>

  <button type="button" onClick={() => insertToken("{primeiro_nome}")} style={tokenBtnStyle}>
    {"{primeiro_nome}"}
  </button>

  <button type="button" onClick={() => insertToken("{nome}")} style={tokenBtnStyle}>
    {"{nome}"}
  </button>
  <p>Clique no botão e insira a variável em sua mensagem. Por exemplo, se colocar a mensagem: "Olá <code>{'{primeiro_nome}'}</code>" a mensagem será entregue como "Olá Danton" ou "Olá Beatriz" e assim por diante.</p>
</div>

      {/* 2) File input logo abaixo */}
      <div className="form-group" style={{ marginBottom: "16px" }}>
        <label htmlFor="fileUpload">
          Anexar arquivo (imagem, PDF, áudio):
        </label>
        <input
  ref={fileInputRef}
  type="file"
  id="fileUpload"
  accept="image/*,.pdf,audio/*,video/*"
  onChange={async (e) => {
    const file = e.target.files[0];

    // Usuário abriu e cancelou
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("arquivo", file);
    setUploadEmAndamento(true);

    try {
      const res = await fetch("/crm-wly/api/whatsapp/upload_temp.php", {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        setArquivoUrl(data.url);
        setTipoMidia(data.tipo_midia);
        setNomeArquivo(file.name);      // 👈 salva o nome bonito
        alert("Arquivo pronto para envio em massa.");
      } else {
        alert("Erro ao processar o arquivo: " + data.message);
        setArquivoUrl("");
        setTipoMidia("");
        setNomeArquivo("");
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (err) {
      console.error("Erro ao enviar arquivo:", err);
      alert("Erro ao enviar arquivo.");
      setArquivoUrl("");
      setTipoMidia("");
      setNomeArquivo("");
      if (fileInputRef.current) fileInputRef.current.value = "";
    } finally {
      setUploadEmAndamento(false);
    }
  }}
/>


{arquivoUrl && (
  <div className="arquivo-info">
    <div className="arquivo-texto">
      <strong>Arquivo pronto:</strong>{" "}
      {nomeArquivo || "Arquivo anexado"}
    </div>

    <button
      type="button"
      className="btn-remover-arquivo"
      onClick={() => {
        setArquivoUrl("");
        setTipoMidia("");
        setNomeArquivo("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }}
    >
      Remover arquivo
    </button>
  </div>
)}

      </div>

        <div className="agendamento-section">
          <label>Agendar envio para:</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="date"
              value={dataAgendamento}
              onInput={(e) => setDataAgendamento(e.target.value)}
              onChange={(e) => setDataAgendamento(e.target.value)}
              onBlur={(e) => setDataAgendamento(e.target.value)}
            />
            <input
              type="time"
              value={horaAgendamento}
              onInput={(e) => setHoraAgendamento(e.target.value)}
              onChange={(e) => setHoraAgendamento(e.target.value)}
              onBlur={(e) => setHoraAgendamento(e.target.value)}
            />
          </div>
        </div>

      <div className="delay-section">
        <label htmlFor="delaySelect">Delay entre mensagens:</label>
        <select
          id="delaySelect"
          value={delaySegundos}
          onChange={(e) => setDelaySegundos(Number(e.target.value))}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px"
          }}
        >
          {[3, 4, 5, 6, 7, 8, 9, 10].map((seg) => (
            <option key={seg} value={seg}>
              {seg} segundos
            </option>
          ))}
        </select>
      </div>

      <div className="alerta-delay">
        ⚠️ Disparos em massa com pouco intervalo entre mensagens aumentam o risco de bloqueio do seu número de WhatsApp.
      </div>

      <div className="botoes-envio">
      <button onClick={fecharPopup} className="cancelar">
        Cancelar
      </button>

<button
  onClick={handleEnviarFila}
  className="confirmar"
  disabled={enviando || uploadEmAndamento}
>
  {uploadEmAndamento
    ? "Aguardando upload..."
    : enviando
    ? "Enviando..."
    : "Confirmar Envio"}
</button>

      </div>
    </div>
  </div>
)}

    </div>
      
  );

}

export default ListagemLeads;
